export default __webpack_public_path__ + "static/Signerica_Fat-7ec7609f2a11742c99591a3d634ceab9.woff";